import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { myConstants } from '../../shares/Constants'
import {setCurrentYear} from './YearSlice'

export const TournamentApi = createApi({
  reducerPath: 'TournamentApi',
  tagTypes: ['Tournament'],
  baseQuery: fetchBaseQuery({
    // hier kommt immer die eigene Hostadresse rein
    baseUrl: myConstants.baseURL,
    prepareHeaders: (headers, { getState }) => 
    {        
      const token = getState().auth.token;
      // console.log("prepare-header:" + token);
      if (token) 
      {
        headers.set('Authorization', `token ${token}`);
      }
      return headers;      
    },    
  }),
  endpoints: (build) => ({
    fetchTournaments: 
      build.query(
        {
          query: () => ({
            url: myConstants.endpoints.api.tournaments,
            method: 'GET',
          }),
          providesTags: 
          [
            {
              type: 'Tournament',
              id: 'LIST',
            }
          ],

          async onQueryStarted( _ , { dispatch, queryFulfilled } )
          {
            try 
            {
              const { data } = await queryFulfilled;                
              let year = null;

              const pathParts = window.location.pathname.split('/').filter(Boolean);
              const yearFromUrl = parseInt(pathParts[0]);

              if (yearFromUrl >= 2015)
              {
                year = yearFromUrl
              }
              else if (data) 
              {
                let currentTournament = data
                // Nur offene Turniere als aktuelle
                .filter(tournament => !tournament.closed)
                // Sortieren nach dem Jahr
                .sort((a,b) => b.year - a.year)[0]
                // ansonsten nehmen wir das letzte Jahr als relevant
                ?? data.slice().sort((a,b) => b.year - a.year)[0];
                year = currentTournament?.year;
              }
              
              dispatch(setCurrentYear(year));
            } 
            catch(error) 
            {              
              // console.log(error);
              dispatch(setCurrentYear(null));
            }
          },
        }
      ),
  
    // Einzelnes (aktuelles) Turnier ermitteln
    fetchTournament: 
      build.query(
        {
          query: (year) => 
          (
            {
              url: myConstants.endpoints.api.base + year + myConstants.endpoints.api.tournament,
              method: 'GET',
            }
          ),
          providesTags: (result, error, year) => 
          [
            {
              type: 'Tournament',
              id: `${year}`
            }
          ]
        }
      ),


    copyTournament:
      build.mutation(
        {
          query: ({year_copy_from, year_copy_to}) =>
          (
            {
              url:  myConstants.endpoints.api.base
                  + year_copy_from
                  + myConstants.endpoints.api.tournament
                  + myConstants.endpoints.actions.tournament.copy
                  + year_copy_to,
              method: 'POST',
            }
          ),          
          invalidatesTags: (result, error, year) => 
          [
            { 
              type: 'Tournament', 
              id: 'LIST' 
            },
            { 
              type: 'Tournament', 
              id: `${year}` 
            },
          ],
        }
      ),
    
    toggleTournamentStatus:
      build.mutation(
        {
          query: (year) =>
          (
            {
              url:  myConstants.endpoints.api.base
                  + year
                  + myConstants.endpoints.api.tournament
                  + myConstants.endpoints.actions.tournament.status,
              method: 'PATCH',
            }
          ),          
          invalidatesTags: (result, error, year) => 
          [
            { 
              type: 'Tournament', 
              id: 'LIST' 
            },
            { 
              type: 'Tournament', 
              id: `${year}` 
            },
          ],
        }
      ),


    updateTournament:
      build.mutation(
        {
          query: ({ year, ...data }) =>
          (
            {
              url:   myConstants.endpoints.api.base
                  + year
                  + myConstants.endpoints.api.tournament
                  + myConstants.endpoints.actions.tournament.update,
              method: 'PATCH',
              body: data,
            }
          ),

          invalidatesTags: (result, error, {year}) =>
          [
            {
              type: 'Tournament',
              id: 'LIST'
            },
            {
              type: 'Tournament',
              id: `${year}`
            },
          ],
        } 
      )
  }),
})

export const { 
  useFetchTournamentsQuery, 
  useLazyFetchTournamentsQuery, 
  useFetchTournamentQuery,
  usePrefetch,
  useCopyTournamentMutation,
  useToggleTournamentStatusMutation,
  useUpdateTournamentMutation,
} = TournamentApi